import PropTypes from 'prop-types';
import React, { Component } from 'react';

export class LargeView extends Component {
  renderContent() {
    const { leftPane, mainPane, mainPaneZeroState, zeroState } = this.props;
    if (leftPane) {
      return [leftPane, mainPane || mainPaneZeroState];
    }

    return zeroState;
  }

  render() {
    const { headerPane, filterPane } = this.props;
    return (
      <div id="content">
        { headerPane }
        <div className="spacer tiny"></div>
        <div className="spacer small"></div>
        <div className="row clearfix">
          <div className="col-xs-12">
            { filterPane || null }
          </div>
          <div className="col-xs-12">
            { this.renderContent() }
          </div>
        </div>
      </div>
    );
  }
}

LargeView.propTypes = {
  headerPane: PropTypes.object,
  filterPane: PropTypes.object,
  leftPane: PropTypes.object,
  mainPane: PropTypes.object,
  mainPaneZeroState: PropTypes.object,
  zeroState: PropTypes.object,
};
